import { useParams } from 'react-router-dom'
import './TGPlusReferalsDetails.scss'
import { Fragment, useEffect, useState } from 'react'
import customerService from 'Services/customerService'
import { ReferalType } from 'Pages/Frontend/Components/TGPlus/ReferAndEarn/ReferAndEarn'
import { BreadCrumb, HorizontalLoader } from 'Components'
import { CurrencyFormatter } from 'Helpers'

const TGPlusReferalsDetails = () => {
  const { id } = useParams<{ id: string }>()

  const [referrals, setReferrals] = useState<ReferalType>()
  const [request, setRequest] = useState<boolean>(false)

  const getReferal = async () => {
    setRequest(true)
    await customerService.customerReferalSingle(id).then(
      (response) => {
        console.log({ response: response.data.data })
        setReferrals(response.data.data)
        setRequest(false)
      },
      (error) => {
        setRequest(false)
      },
    )
  }

  useEffect(() => {
    getReferal()
  }, [id])

  return (
    <div className='TGPlusReferalsDetails'>
      <div className='container'>
        <BreadCrumb
          title={'Referrals'}
          parent={'Tradegrid Plus'}
          parentUrl={'tgplus-subscription'}
          showTitle={false}
        ></BreadCrumb>

        <div className='title'>
          <b>Referral ID:</b> {referrals?.id}{' '}
          <span
            className={referrals?.referralStatus === 'PENDING' ? 'status-pending' : 'status-paid'}
          >
            {referrals?.referralStatus}
          </span>
        </div>
        <div className='row mt-4'>
          <div className='col-md-6'>
            <div className='sub-title'>Existing Customer Details</div>
            <div className='card border-0'>
              <div className='card-body'>
                {request && <HorizontalLoader></HorizontalLoader>}

                {!request && (
                  <div className='row'>
                    <div className='col-6 label'>Fullname</div>
                    <div className='col-6 text-end value'>
                      {referrals?.customer.firstName} {referrals?.customer.lastName}
                    </div>
                    <div className='col-6 label'>Phone number</div>
                    <div className='col-6 text-end value'>{referrals?.customer.msisdn}</div>
                    <div className='col-6 label'>Account ID</div>
                    <div className='col-6 text-end value'>{referrals?.customer.accountId}</div>
                    <div className='col-6 label'>Total earnings</div>
                    <div className='col-6 text-end value'>
                      ₦{CurrencyFormatter(Number(referrals?.referralBonusAmount))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='sub-title'>Earnings Breakdown</div>
            <div className='card border-0'>
              <div className='card-body'>
                {request && <HorizontalLoader></HorizontalLoader>}
                {!request && (
                  <Fragment>
                    <div className='card mb-3 wallet'>
                      <div className='card-body'>
                        <div className='wallet-label'>Total Amount Earned</div>
                        <div className='wallet-value'>
                          ₦{CurrencyFormatter(Number(referrals?.referralBonusAmount))}
                        </div>
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-6 label'>Payout status</div>
                      <div className='col-6 text-end value'>
                        <span
                          className={
                            referrals?.referralStatus === 'PENDING'
                              ? 'status-pending'
                              : 'status-paid'
                          }
                        >
                          {referrals?.referralStatus}
                        </span>
                      </div>
                      <div className='col-6 label'>Payout Date</div>
                      <div className='col-6 text-end value'>-</div>
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className='col-md-6 mt-2'>
            <div className='sub-title'>Referred Customer Details</div>
            <div className='card border-0'>
              <div className='card-body'>
                {request && <HorizontalLoader></HorizontalLoader>}
                {!request && (
                  <div className='row'>
                    <div className='col-6 label'>Fullname</div>
                    <div className='col-6 text-end value'>
                      {referrals?.customer.firstName} {referrals?.referralName}
                    </div>
                    <div className='col-6 label'>Phone number</div>
                    <div className='col-6 text-end value'>{referrals?.phoneNumber}</div>
                    <div className='col-6 label'>Business Name</div>
                    <div className='col-6 text-end value'>{referrals?.businessName}</div>
                    <div className='col-6 label'>Referral ID</div>
                    <div className='col-6 text-end value'>{referrals?.id}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TGPlusReferalsDetails
